













































import { Component, Vue } from "vue-property-decorator";
import firebase from "firebase";
import UserModel, { UserDb } from "@/models/User";
import _debug from "debug";

const debug = _debug("Mediacao:views:Users.vue");

@Component({
    components: {},
})
export default class Processos extends Vue {
    private users: UserDb[] = [];
    private loadingUsers = true;
    private textoBusca = "";
    private filtroPerfil: string[] = ["admin", "mediador", "parte"];

    private created() {
        this.fetchUsers();
    }

    public get isLoadingUsers(): boolean {
        return this.loadingUsers;
    }

    public get filteredUsers(): UserDb[] {
        const filtro = this.filtroPerfil;
        debug("Filtrando usuarios:", this.users, filtro);
        const filtered = this.users.filter(user => {
            return UserModel.hasRoleOf(filtro, user.roles ? user.roles : []);
        });
        debug("Filtered users", filtered);
        return filtered;
    }

    private async fetchUsers() {
        const usersFirst = firebase
            .firestore()
            .collection("users")
            .limit(20);

        const usersSnapshots = await usersFirst.get();
        debug("Feteched Users", usersSnapshots);
        const myUsers = this.users;
        usersSnapshots.forEach(doc => {
            debug("pushing user", doc.data());
            myUsers.push(doc.data());
        });
        this.loadingUsers = false;
    }
}
